// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
// import uview from 'uview-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import './styles/global.css'; // 引入全局样式
import router from './router'  //这个要放在最下面，否则打包后输入框组件样式会丢失

Vue.config.productionTip = false
// 使UI全局可用
Vue.use(ElementUI); 
// Vue.use(uview); 

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js